import { Component, Input } from '@angular/core';
import { Check, LucideAngularModule } from 'lucide-angular';
import { EventGuestModel } from '@app/events/shared/event-guest.model';

/**
 * TVG-267: read-only accommodation indicator for the guest list row. Shows a
 * green tick when the guest requires overnight accommodation and a muted em
 * dash when they do not, replacing the previous raw "true" value that was
 * unreadable and easily mistaken for a rendering error. The flag itself is set
 * from the Add/Edit guest modal checkbox and the bulk "Mark as accommodation"
 * action, so this column stays purely presentational.
 */
@Component({
  selector: 'app-guest-accommodation-column',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './guest-accommodation-column.component.html',
})
export class GuestAccommodationColumnComponent {
  @Input('item') public item!: EventGuestModel;

  protected readonly CheckIcon = Check;
}
